/**
 * Offcanvas interactions/toggle
 */
import { gsap } from "gsap";
import { CustomEase } from "gsap/CustomEase";
import { lodgingGallery } from "./lodgingGallery";

gsap.registerPlugin(CustomEase);

CustomEase.create("quick", "M0,0 C0.25,0 0.306,0.114 0.335,0.154 0.424,0.276 0.426,0.358 0.462,0.512 0.51,0.786 0.534,0.874 0.63,0.94 0.673,0.97 0.698,1 1,1");

export function offCanvas() {
  const offcanvasToggles = Array.from(document.getElementsByClassName('js-offcanvas-toggle'));
  const body = document.body;

  if(offcanvasToggles) {
    for(const offcanvasToggle of offcanvasToggles) {
      let offcanvasOpen = false;
      const offcanvasTarget = offcanvasToggle.dataset.offcanvasOpen;
      const offcanvas = document.querySelector(`[data-offcanvas="${offcanvasTarget}"]`);
      const offcanvasBG = offcanvas.querySelector('.offcanvas__bg');
      const offcanvasPanel = offcanvas.querySelector('.offcanvas__content');
      const offcanvasFooter = offcanvas.querySelector('.offcanvas__actions');
      const offcanvasCloseBtns = Array.from(offcanvas.getElementsByClassName('js-offcanvas-close'));
      const offcanvasNavBtns = Array.from(offcanvas.getElementsByClassName('offcanvas__nav__btn'));
      const hasNestedToggles = Array.from(offcanvas.getElementsByClassName('js-offcanvas-toggle'));

      if (hasNestedToggles) {
        hasNestedToggles.forEach((item) => {
          offcanvasCloseBtns.push(item);
        })
      }

      const tl = gsap.timeline({
        paused: true,
      })

      tl.to(offcanvas, { display: 'block' }, 'afterBG');
      tl.to(offcanvasBG,{ duration: 0.6, scaleX: 1, alpha: 1, ease: 'quick' }, 'afterBG')
        .fromTo(offcanvasPanel, { alpha: 0.0001, x: 24 }, { duration: 0.375, alpha: 1, x: 0, ease: 'power3.out' }, '-=0.185')

      if (offcanvasFooter) {
        tl.fromTo(offcanvasFooter, { alpha: 0.0001, x: 24 }, { duration: 0.375, alpha: 1, x: 0, ease: 'power3.out' }, '<');
      }

      for (const offcanvasCloseBtn of offcanvasCloseBtns) {
        const offcanvasCloseIcon = offcanvas.querySelector('.icon');
        const offcanvasCloseBG = offcanvas.querySelector('.offcanvas__close__bg');
        let hasToStayOpen = false;

        tl.fromTo(offcanvasCloseIcon, { alpha: 0.0001 }, { duration: 0.3, alpha: 1, ease: 'power1.out' }, 'afterBG+=0.485')
          .fromTo(offcanvasCloseBG, { scaleX: 0.0001, transformOrigin: 'left' }, { duration: 0.5, scaleX: 1, ease: 'expo.out' }, 'afterBG+=0.485');

        if(offcanvasNavBtns.length > 0) {
          hasToStayOpen = true;
          tl.fromTo(offcanvasNavBtns, { alpha: 0.0001, x: 8 }, { duration: 0.4, alpha: 1, x: 0, ease: 'power1.out', stagger: 0.15 }, 'afterBG+=0.515');
        }

        offcanvasCloseBtn.addEventListener('click', () => {
          if (offcanvasCloseBtn.classList.contains('offcanvas__nav__btn')) {
            offcanvasClose(hasToStayOpen, tl);
          } else {
            offcanvasClose(false, tl);
          }
        });
      }

      document.addEventListener('keydown', (evt) => {
        if(evt.code === 'Escape' && offcanvasOpen) {
          offcanvasClose(false, tl);
        }
      });

      offcanvasToggle.addEventListener('click', function() {
        if (offcanvasOpen) {
          offcanvasClose(false, tl);
        } else {
          offcanvasOpen = true;
          body.classList.add('offcanvas-open');
          offcanvas.classList.add('offcanvas--opened');
          tl.timeScale(1);
          tl.play();

          const lodgingGalleryEl = document.querySelector('.js-lodging-gallery:not(.swiper-initialized)');
          if(document.querySelector('.filter--dropdown-active')) {
            document.querySelector('.filter--dropdown-active').classList.remove('filter--dropdown-active');
          }

          if (lodgingGalleryEl) {
            lodgingGallery();
          }
        }
      });

      const offcanvasClose = function(hasToStayOpen, timeline) {
        offcanvasOpen = false;
        timeline.timeScale(1.25);
        timeline.reverse();

        if (hasToStayOpen) {
          offcanvas.classList.remove('offcanvas--opened');
        } else {
          body.classList.remove('offcanvas-open');
          offcanvas.classList.remove('offcanvas--opened');
        }
      }
    }
  }
}

offCanvas();
